/* istanbul ignore file */
import React from 'react';
import { CreateBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import PurchaseOrderBreadcrumbs from 'domain/finance/purchaseOrder/shared/PurchaseOrderBreadcrumbs';

const CreatePurchaseOrderBreadcrumbs = () => {
  return (
    <PurchaseOrderBreadcrumbs>
      <CreateBreadcrumbItem entity="Purchase Order" />
    </PurchaseOrderBreadcrumbs>
  );
};

export default CreatePurchaseOrderBreadcrumbs;
